/**
 * UserIdManager - manages userId without URL parameters
 * This prevents Keycloak redirect_uri validation issues
 */

const USER_ID_KEY = 'UserId';
const FIRST_ENTRY_KEY = 'FirstEntry';

export class UserIdManager {
  /**
   * Get userId from localStorage
   */
  static getUserId(): string | null {
    const userId = localStorage.getItem(USER_ID_KEY);
    return userId && userId !== 'null' ? userId : null;
  }

  /**
   * Set userId in localStorage
   */
  static setUserId(userId: string): void {
    if (userId && userId !== 'null') {
      localStorage.setItem(USER_ID_KEY, userId);
      console.log('[UserIdManager] UserId saved:', userId);
    }
  }

  /**
   * Check if this is the first entry
   */
  static isFirstEntry(): boolean {
    return localStorage.getItem(FIRST_ENTRY_KEY) === null;
  }

  /**
   * Mark that user has entered before
   */
  static markFirstEntryComplete(): void {
    localStorage.setItem(FIRST_ENTRY_KEY, 'no');
  }

  /**
   * Clear userId (on logout)
   */
  static clearUserId(): void {
    localStorage.removeItem(USER_ID_KEY);
    localStorage.removeItem(FIRST_ENTRY_KEY);
    console.log('[UserIdManager] UserId cleared');
  }

  /**
   * Initialize userId if not present
   * Returns true if userId exists, false if needs to be generated
   */
  static ensureUserId(): boolean {
    const userId = this.getUserId();
    if (userId) {
      return true;
    }
    
    // UserId will be set by DefaultRegister API or Keycloak
    return false;
  }
}

